// Translator notes: HV → FI/EN wishes, permissions and "let us" — a bare infinitive with its agent
// (engine rules/infinitive-commands.ts; the Finnish choices are explained there).
// Each id is an engine note (`notes.add(text, id, args)`); collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  infLetMe: {
    args: ['agent', 'verb'],
    fi: (a: string[]) => `Datiivi ”${a[0]}” ja infinitiivi ”${a[1]}” pyytävät lupaa: ’anna minun …’ (Daenerysin ”Ynot rēbagon” = anna minun mennä ohi).`,
    en: (a) => `The dative “${a[0]}” with the infinitive “${a[1]}” asks for permission: “let me …” (Daenerys’s “Ynot rēbagon” = let me pass).`,
  },
  infLetUs: {
    args: ['agent', 'verb'],
    fi: (a: string[]) => `”${a[0]}” ’meille’ ja infinitiivi ”${a[1]}” on kehotus ’tehkäämme’ (”Sesīr īlot jagon!” = menkäämme nyt!).`,
    en: (a) => `“${a[0]}” (to us) with the infinitive “${a[1]}” is “let us …” (“Sesīr īlot jagon!” = now let us go!).`,
  },
  infLetUsVoc: {
    args: ['agent', 'verb'],
    fi: (a: string[]) =>
      `Vokatiivi ”${a[0]}” ’me’ ja infinitiivi ”${a[1]}” ovat kehotus ’tehkäämme’ kuten ”īlot” ja infinitiivi; kysymyksenä ’teemmekö?’ (”Īlos pradagon?” = aloitammeko?).`,
    en: (a) =>
      `The vocative “${a[0]}” (we) with the infinitive “${a[1]}” is “let us …”, as “īlot” with an infinitive; as a question “shall we …?” (“Īlos pradagon?” = shall we begin?).`,
  },
  infYouMay: {
    args: ['agent', 'verb'],
    fi: (a: string[]) => `Datiivi ”${a[0]}” ja infinitiivi ”${a[1]}” antavat luvan: ’saat …’ (”Aōt vaodekuragon” = saat lähestyä).`,
    en: (a) => `The dative “${a[0]}” with the infinitive “${a[1]}” gives permission: “you may …” (“Aōt vaodekuragon” = you may approach).`,
  },
  infLetThird: {
    args: ['agent', 'verb'],
    fi: (a: string[]) =>
      `Datiivi ”${a[0]}” ja infinitiivi ”${a[1]}” antavat luvan kolmannelle: suomeksi 3. persoonan imperatiivi (”Zijot māzigon” = tulkoon hän).`,
    en: (a) => `The dative “${a[0]}” with the infinitive “${a[1]}” lets someone else act: “let him/her …” (“Zijot māzigon” = let him come).`,
  },
  infJussive: {
    args: ['agent', 'verb'],
    fi: (a: string[]) =>
      `Vokatiivi ”${a[0]}” ja infinitiivi ”${a[1]}” ovat käsky tai toive kolmannelle: suomeksi 3. persoonan imperatiivi (”Bōsirī zirys jemēbagon” = hallitkoon hän kauan).`,
    en: (a) =>
      `The vocative “${a[0]}” with the infinitive “${a[1]}” is a command or wish for someone else: “let … / may …” (“Bōsirī zirys jemēbagon” = long may she reign).`,
  },
  infAgentWordLost: {
    args: ['word', 'agent'],
    fi: (a: string[]) => `Sana ”${a[0]}” luettiin pronominin ”${a[1]}” määreeksi, eikä se näy käännöksessä.`,
    en: (a) => `“${a[0]}” was read as a modifier of the pronoun “${a[1]}” and is not in the translation.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
